
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deadrop-snapshot-6-reveal",
      function () {
        return require("private-next-pages/deadrop-snapshot-6-reveal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deadrop-snapshot-6-reveal"])
      });
    }
  